import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Patient} from '../models/patient';
import {AuthToken} from '../models/authToken';
import {isNull} from 'util';
import {DisclaimerService} from './disclaimer.service';
import {StorageService} from './storage.service';
import { CookieService } from 'ngx-cookie-service';
import {CompteService} from './compte.service';

@Injectable({
    providedIn: 'root'
})
export class TrackingService {
    authToken: AuthToken;
    currentPatient: Patient;
    patientId: string;
    userID: string;

    constructor(
        private disclaimer: DisclaimerService,
        private storageService: StorageService,
        private cookieService: CookieService,
        private compteService: CompteService
    ) {
    }

    getCookieConsent() {
        let cookieConsent = false;
        const cookiesValue = this.cookieService.get('oap-cookies-consent');
        if (cookiesValue === 'true') {
            cookieConsent = true;
        }
        return cookieConsent;
    }

    contact(url: string, label: string) {
        const a = window.document.createElement('a');
        a.href = 'mailto:' + url;
        a.click();

        this.pushDataLayer('Demande de contact', 'Click', label);
    }

    trackingLinks(url: string) {
        this.pushDataLayer('Lien sortant', 'Click', url);
        window.open(url);
    }

    openExternal(url: string) {
        this.pushDataLayer('Lien sortant', 'Click', url);
        this.disclaimer.openPopinExternal(url);
    }


    pushDataLayer(category: string, action: string, label: string) {
        if (this.getCookieConsent() === true) {
            window['dataLayer'].push({
                'category': category,
                'action': action,
                'label': label,
                'event': 'ua_event_ready'
            });
        }
    }

    pushDataLayerDelivery(category: string, action: string, orders: Array<any>) {
        orders.forEach((order, index) => {
            let pushObject = {
                'category': category,
                'action': action,
                'event': 'update_ua_event'
            };
            pushObject['label'] = order.label;
            pushObject['product_detail_order' + (index + 1)] = order.products.join(" | ");
            pushObject['orderID_' + (index + 1)] = order.orderID;
            if (this.getCookieConsent() === true) {
                window['dataLayer'].push(pushObject);
            }
        });
    }

    DataLayer(PageName: string, PageType: string, Category: string, SubCategory: string) {
        this.patientId = '';
        this.userID = '';
        let Env = 'Test';

        if (environment.production) {
            Env = 'prod';
        } else if (environment.preprod) {
            Env = 'preprod';
        }

        //console.log(Env);

        this.authToken = JSON.parse(localStorage.getItem('currentUser'));
        if (!isNull(this.authToken)) {
            const typeAccount = JSON.parse(localStorage.getItem('type'));
            //console.log('type account : ' + typeAccount);
            if (typeAccount !== null && typeAccount === 'P' && isNaN(parseInt(JSON.parse(localStorage.getItem('patientId'))))) {
                this.compteService.getPatientsAffiliated(this.authToken.id).subscribe(data => {
                    if (!isNull(data[0].identifiantSAP)) {
                        this.patientId = data[0].identifiantSAP.toString();
                    }
                    this.userID = data[0].patientKey.toString();
                    if (this.getCookieConsent() === true) {
                            window['dataLayer'].push({
                                'Env': Env,
                                'PageName': PageName,
                                'PageType': PageType,
                                'Category': Category,
                                'SubCategory': SubCategory,
                                'UserID': this.userID,
                                'ProfileID': this.patientId,
                                'event': 'gtm.ready'
                            });
                        }
                    }
                );
            } else {
                const ls_patient = localStorage.getItem('patientCurrent');
                const json_ls_patient = JSON.parse(ls_patient);
                if (json_ls_patient !== null && !isNull(json_ls_patient.identifiantSAP)) {
                //if (ls_patient !== null && !isNull(JSON.parse(localStorage.getItem('patientCurrent')).identifiantSAP)) {
                    this.patientId = json_ls_patient.identifiantSAP.toString();
                }
                this.userID = JSON.parse(localStorage.getItem('patientId'));

                this.storageService.watchStorage().subscribe((data: string) => {
                    const ls_patientCurrent = localStorage.getItem('patientCurrent');
                    
                    if (!isNull(ls_patientCurrent) &&  !isNull(JSON.parse(ls_patientCurrent).identifiantSAP)) {
                        this.patientId = JSON.parse(ls_patientCurrent).identifiantSAP.toString();
                    }
                    this.userID = JSON.parse(localStorage.getItem('patientId'));
                });

                if (this.getCookieConsent() === true) {
                    window['dataLayer'].push({
                        'Env': Env,
                        'PageName': PageName,
                        'PageType': PageType,
                        'Category': Category,
                        'SubCategory': SubCategory,
                        'UserID': this.userID,
                        'ProfileID': this.patientId,
                        'event': 'gtm.ready'
                    });
                }
            }
        } else {
            console.log('Cookie consent');
            if (this.getCookieConsent() === true) {
                window['dataLayer'].push({
                    'Env': Env,
                    'PageName': PageName,
                    'PageType': PageType,
                    'Category': Category,
                    'SubCategory': SubCategory,
                    'UserID': this.userID,
                    'ProfileID': this.patientId,
                    'event': 'gtm.ready'
                });
            }
        }
    }
}
